if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {
      super();
      this.index = 0;
      this.autoplayDelay = 5000;
    }

    connectedCallback() {
      // Lógica diferida hasta que children estén parseados en DOM
      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.length = this.content.length;

      if ( this.length === 0 ) return;

      // Nav buttons activos desde el inicio (cíclico, sin "disabled" state)
      if ( this.nextButton ) this.nextButton.classList.remove('announcement-bar__content-nav--disabled');
      if ( this.prevButton ) this.prevButton.classList.remove('announcement-bar__content-nav--disabled');

      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', ()=>{
          this.changeSlide('next');
          this.resetAutoplay();
        });
      }
      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', ()=>{
          this.changeSlide('prev');
          this.resetAutoplay();
        });
      }

      // Autoplay solo si hay más de 1 mensaje
      if ( this.length > 1 ) {
        this.startAutoplay();
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        // Pausar autoplay si el tab pierde foco (ahorra batería)
        document.addEventListener('visibilitychange', () => {
          if ( document.hidden ) this.stopAutoplay();
          else this.startAutoplay();
        });
      }
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    changeSlide(direction) {
      if ( direction === 'next' ) {
        this.index = (this.index + 1) % this.length;
      } else if ( direction === 'prev' ) {
        this.index = (this.index - 1 + this.length) % this.length;
      }

      if ( !this.slider || !this.content[this.index] ) return;

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });
    }

    startAutoplay() {
      if ( this.autoplay ) return; // evita doble interval
      this.autoplay = setInterval(() => this.changeSlide('next'), this.autoplayDelay);
    }

    stopAutoplay() {
      if ( this.autoplay ) {
        clearInterval(this.autoplay);
        this.autoplay = null;
      }
    }

    resetAutoplay() {
      this.stopAutoplay();
      if ( this.length > 1 ) this.startAutoplay();
    }

  }

  if ( typeof customElements.get('announcement-bar') === 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

}
